var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/structure/FormHint/index.jsx";
import React from 'react';
import PropTypes from 'prop-types';
export default function FormHint(props) {
  var error = props.error,
    warning = props.warning,
    info = props.info;
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-hint form-hint--error",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 16
      }
    }, error);
  }
  if (warning) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-hint form-hint--warning",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 16
      }
    }, warning);
  }
  if (info) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-hint form-hint--info",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 16
      }
    }, info);
  }
  return null;
}
;
FormHint.propTypes = {
  error: PropTypes.string,
  warning: PropTypes.string,
  info: PropTypes.string
};
FormHint.defaultProps = {
  error: null,
  warning: null,
  info: null
};